import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { ReplyService } from '../../../services';
import { SurveyLevelAnswer } from '../../../classes';

@Injectable()
export class ReplyDataResolve implements Resolve<Partial<SurveyLevelAnswer>> {

  constructor(
    protected reply:ReplyService,
  ) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Partial<SurveyLevelAnswer>> {
    const survey_id:string = route.paramMap.get('survey_id') || route.queryParamMap.get('survey_id'); 
    return this.reply.getLatest(survey_id).pipe(share())
  }
}
